import React from 'react';
import { Alert, Button, Collapse } from 'antd';
import { LinkOutlined, SwapOutlined } from '@ant-design/icons';
import './finance-reconciliation.css';

export default function FinanceReconciliationPanel({
  reconciliation,
  onNavigateCompare,
  compareLabel = 'Open with equivalent filters',
  defaultOpen = false,
  className = '',
}) {
  if (!reconciliation) return null;

  const {
    compare_with_label: compareWithLabel,
    user_summary: userSummary,
    why_numbers_differ: whyNumbersDiffer,
    matches_total_approved_cost: matchesTotal,
  } = reconciliation;

  const bullets = Array.isArray(whyNumbersDiffer) ? whyNumbersDiffer : [];
  const hasBody = userSummary || bullets.length > 0 || onNavigateCompare;

  if (!hasBody && matchesTotal !== false) return null;

  return (
    <Collapse
      bordered={false}
      className={`finance-reconcile-panel ${className}`.trim()}
      defaultActiveKey={defaultOpen ? ['reconcile'] : []}
      items={[
        {
          key: 'reconcile',
          label: (
            <span className="finance-reconcile-panel__label">
              <SwapOutlined />
              {userSummary
                ? 'Why doesn’t this match the other screen?'
                : `Compare with ${compareWithLabel || 'related report'}`}
            </span>
          ),
          children: (
            <div className="finance-reconcile-panel__body">
              {userSummary ? (
                <p className="finance-reconcile-panel__note">{userSummary}</p>
              ) : null}
              {bullets.length > 0 ? (
                <ul className="finance-reconcile-panel__gaps">
                  {bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
              {process.env.NODE_ENV === 'development' && matchesTotal === false ? (
                <Alert
                  type="warning"
                  showIcon
                  className="finance-reconcile-panel__dev-alert"
                  message="Internal: status bucket sums do not match headline total_approved_cost"
                />
              ) : null}
              {onNavigateCompare ? (
                <Button
                  type="link"
                  icon={<LinkOutlined />}
                  className="finance-reconcile-panel__cta"
                  onClick={onNavigateCompare}
                >
                  {compareLabel}
                </Button>
              ) : null}
            </div>
          ),
        },
      ]}
    />
  );
}
